

import { CircularProgress, Container, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import UserApi from "../api/UserApi";
import { useParams } from "react-router-dom";
import axios from "axios";


const CheckAuthPage = () => {
    const [loading, setLoading] = React.useState(false);
    const { key,roleName } = useParams();




    const generateSharedKey = (ip) => {
        var res = '';

        ip.toString().split('.').map((p) => {
            if (p.length === 3) res = res + p
            else if (p.length === 2) res = res + '0' + p
            else res = res + '00' + p
        })
        return res;
    }
    useEffect(() => {
        checkip();
    }
        , []);


    const checkip = async () => {
        setLoading(true);
        const res = await axios.get("https://api.ipify.org/?format=json");
        checkAuth(res.data.ip);
        setLoading(false);
    };


    const checkAuth = (ip) => {
        const skey = generateSharedKey(ip);
        if (skey !== "") {
            return UserApi.CheckAuth(key, skey,roleName).then((res) => {
                localStorage.setItem("token", res.data.access_token);
                window.location.pathname = "/Dashboard";
            })
                .catch(err => {
                    console.log(err)
                    window.location.pathname = "/login";
                });
        }

    }


    return (
        <Container component="main" maxWidth="xs">
            <Typography component="h1" variant="h5" sx={{ display: "flex", alignItems: "center" }}>
                در حال بررسی اطلاعات کاربر ...
                {loading && <CircularProgress color="inherit" size="20px" sx={{ mx: '0.5rem' }} />}
            </Typography>
        </Container>
    );

}
export default CheckAuthPage;